import React from 'react';
import './Chapters.scss';

function Chapter3() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        “With sequencing technology becoming cheaper, we’re able to get more and more data, which is
        fabulous,” Dr. Hogg says. But having more data means the team needs more compute power. The
        <a href="https://aws.amazon.com/" target="_blank" rel="sponsored">
          {' '}
          AWS
        </a>{' '}
        cloud,{' '}
        <a
          href="https://www.intel.com/content/www/us/en/partner/showcase/aws/overview.html"
          target="_blank"
          rel="sponsored"
        >
          Intel
        </a>{' '}
        technology, and the RONIN interface allow Dr. Hogg and her team to scale their
        data-processing capacity to match the size of their datasets, never paying for more than
        what they need.
      </p>

      <p className="chapter__paragraph">
        “Rather than trying to make our data fit the compute that we had available, we just make the
        compute fit the data that we have,” Dr. Hogg says. “And it’s given us that flexibility to be
        able to do our analysis in a more rapid fashion than ever before.”
      </p>
    </section>
  );
}

export default Chapter3;
